import { Product, ProductsActionTypes, ProductSorting } from './types';

export interface ProductsState {
  loading: boolean;
  items: Product[];
  recommendedItems: Product[];
  limit: number;
  itemCount: number;
  totalItems: number;
  page: number;
  pageCount: number;
  filter: object;
  activeHash: string;
  sort: ProductSorting;
}

export const initialState: ProductsState = {
  loading: false,
  items: [],
  recommendedItems: [],
  page: 1,
  limit: 20,
  sort: ProductSorting.BEST_MATCH,
  itemCount: null,
  totalItems: null,
  pageCount: null,
  activeHash: null,
  filter: {
    dateFrom: null,
    dateTo: null,
  },
};

export function productsReducer(state = initialState, action: ProductsActionTypes): ProductsState {
  switch (action.type) {
    case 'CLEAN_PRODUCTS':
      return {
        ...state,
        items: [],
        recommendedItems: [],
        page: 1,
        limit: initialState.limit,
        filter: initialState.filter,
      };
    case 'GOTO_PRODUCTS_NEXT_PAGE':
      return {
        ...state,
        page: state.page + 1,
      };
    case 'SET_PRODUCTS_PAGE_LIMIT':
      return {
        ...state,
        limit: action.payload,
      };
    case 'LOAD_PRODUCTS_REQUESTED': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'LOAD_PRODUCTS_SUCCEEDED':
      const { items, recommendedItems, ...payload } = action.payload;
      return {
        ...state,
        loading: false,
        ...payload,
        items: [...state.items, ...items],
        recommendedItems: recommendedItems || [],
      };
    case 'SET_PRODUCTS_FILTER':
      return {
        ...state,
        filter: action.payload,
      };
    case 'SET_PRODUCTS_SORTING':
      return {
        ...state,
        page: 1,
        items: [],
        sort: action.payload,
      };
    case 'SET_ACTIVE_HASH':
      return {
        ...state,
        activeHash: action.payload,
      };
    default:
      return state;
  }
}
